import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import * as abc from 'src/assets/js/masonry.pkgd.min.js';
import Masonry from 'masonry-layout';
import * as imagesLoaded from 'src/assets/js/imagesloaded.pkgd.min.js';
import smoothscroll from 'smoothscroll-polyfill';

@Component({
	selector      : 'app-content-tab',
	templateUrl   : './content-tab.component.html',
	encapsulation : ViewEncapsulation.None,
	host: {
		'(window:resize)': 'onResize($event)'
	}
})

export class ContentTabComponent implements OnInit {
	@Input() tabContentData : any;
	@Input() tagClass       : any;
	@Input() programmeData  : any;
	public isMobile : boolean;
	public loggedIn : boolean = false;

	constructor(
		private meta     : Meta,
	) {
		smoothscroll.polyfill();
		if ( devicePixelRatio > 1.5 && document.body.clientWidth < 767 )
            this.isMobile = true;
        else
            this.isMobile = false;
		if ( 'userData' in window.localStorage )
            this.loggedIn = true;
	}

	ngOnInit() {
		setTimeout( () => {
			document.querySelectorAll('.scroll-to-content').forEach(function(value) {
				let href_link = value.getAttribute( 'href' );
				value.setAttribute( 'href', 'javascript:void(0);' );
				value.addEventListener( "click", function( e ) {
				    let link = href_link.split( '#' );
				    const scrollElement = document.getElementById( link[1] );
					const yCoordinate = scrollElement.getBoundingClientRect().top + window.pageYOffset;
					let yOffset;
					yOffset = -60;
					window.scrollTo({
						top: yCoordinate + yOffset,
						behavior: 'smooth'
					});
				}, false );
			});
		}, 1 )
	}

	ngAfterViewInit() {
		// if ( this.tabContentData ) {
		// 	if ( this.tabContentData.tcb_cover_image != false ) {
		// 		this.meta.updateTag({ name: 'twitter:image', content: this.tabContentData.tcb_cover_image.url });
		// 		this.meta.updateTag({ property: 'og:image', content: this.tabContentData.tcb_cover_image.url });
		// 	} else {
		// 		if ( this.tabContentData.tcb_sbc_image ) {
		// 			this.meta.updateTag({ name: 'twitter:image', content: this.tabContentData.tcb_sbc_image.url });
		// 			this.meta.updateTag({ property: 'og:image', content: this.tabContentData.tcb_sbc_image.url });
		// 		}
	
		// 		if ( this.tabContentData.tcb_image ) {
		// 			this.meta.updateTag({ name: 'twitter:image', content: this.tabContentData.tcb_image.url });
		// 			this.meta.updateTag({ property: 'og:image', content: this.tabContentData.tcb_image.url });
		// 		}
		// 	}
		// }
		setTimeout (
			() => {
				if ( document.querySelectorAll( '.haf_width' ) ) {
					var elems = document.querySelectorAll( '.haf_width' );
					[].forEach.call( elems, function( el ) {
						var contfElemmsnry = new Masonry( el, {
							itemSelector: '.tab-content__repeater',
							columnWidth: '.grid-sizer-2',
							horizontalOrder: true,
							percentPosition: true,
						});

						imagesLoaded( el ).on( 'progress', function() {
							contfElemmsnry.layout();
						});
					});
				}

				this.addStyle();

				if ( document.querySelector( '.scroll-to-content' ) ) {
					document.querySelectorAll('.scroll-to-content').forEach(function(value) {
						let href_link = value.getAttribute( 'href' );
						value.setAttribute( 'href', 'javascript:void(0);' );
						value.addEventListener( "click", function( e ) {
						    let link = href_link.split( '#' );
						    const scrollElement = document.getElementById( link[1] );
							const yCoordinate = scrollElement.getBoundingClientRect().top + window.pageYOffset;
							let yOffset;

							yOffset = -60;

							window.scrollTo({
								top: yCoordinate + yOffset,
								behavior: 'smooth'
							});
						}, false );
					});
				}
			}, 1
		);
	}

	onResize( event ) {
		if ( document.querySelector( '.haf_width' ) ) {
			var contfElem = document.querySelector( '.haf_width' );
			var contfElemmsnry = new Masonry( contfElem, {
				itemSelector: '.tab-content__repeater',
				columnWidth: '.grid-sizer',
				horizontalOrder: true,
				percentPosition: true,
			});
		}
		this.addStyle();
	}

	accordion( event : any, classname : string ) {
		const target   = event.target;
		const hasClass = target.parentElement.classList.contains( classname );
		if( hasClass )
			target.parentElement.classList.remove( classname );
		else {
			var elems = document.querySelectorAll( '.' + classname );
			[].forEach.call( elems, function( el ) {
				el.classList.remove( classname );
			});
			target.parentElement.classList.add( classname );
		}
		if ( this.isMobile ) {
			setTimeout( () => {
				const scrollElement = document.querySelector( '.' + classname );
				const yCoordinate = scrollElement.getBoundingClientRect().top + window.pageYOffset;
				let yOffset;
				yOffset = -60;
				window.scrollTo({
					top: yCoordinate + yOffset,
					behavior: 'smooth'
				});
			}, 1 );
		}
	}

	addStyle() {
		if ( document.querySelector( '.figure-type.out_of_boundary' ) && document.getElementById( 'out_of_boundary' ) ) {
			var outOfBoundary = document.querySelector( ".figure-type.out_of_boundary" ).getBoundingClientRect().left;
			document.getElementById( 'out_of_boundary' ).style.marginLeft = "-" + outOfBoundary + "px";
			document.getElementById( 'out_of_boundary' ).style.opacity = "1";
		}
	}

	goToLoginPage( link ) {
		document.getElementById( 'pageaccountclick' ).click();
		window.localStorage.setItem( 'httpReferer', link );
	}
}